const getArrayFromObject = (object: Record<string, string>): { text: string; value: string }[] => {
    const objectAsArray = Object.entries(object);
    return objectAsArray.length > 0 ? Object.entries(object).map((arr) => ({ text: arr[1], value: arr[0] })) : [];
};

export default getArrayFromObject;
